<script>
export default {
    name: 'IlluCoachingScolaire',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-coaching-scolaire"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <g :stroke="secondaryColor" class="secondary-color">
                <path
                    d="M32 11.5c-7.161 0-12.705 2.345-16.615 7.069C11.552 23.2 9.29 30.087 8.56 39.21c5.367-2.216 13.178-3.336 23.44-3.336 10.261 0 18.072 1.12 23.44 3.338-.73-9.125-2.992-16.012-6.825-20.644C44.705 13.845 39.16 11.5 32 11.5zM32 8.5c-1.011 0-1.815.273-2.396.854-.504.503-.836 1.223-1.018 2.146h6.828c-.182-.923-.514-1.643-1.018-2.146-.58-.581-1.385-.854-2.396-.854z"
                />
                <path
                    d="M26 12.5c-7.904 6.222-11.237 14.222-10 24M38 12.5c7.733 6.815 11.237 14.222 10 24"
                    stroke-linecap="round"
                />
            </g>
            <path
                d="M32 16c-2.76 0-5 2.223-5 4.965V32h3.612v-4.414h2.777V32H37V20.965C37 18.223 34.762 16 32 16zm-1.388 8.276v-3.31c0-.762.621-1.38 1.388-1.38.767 0 1.39.618 1.39 1.38v3.31h-2.778z"
                :fill="primaryColor" class="primary-color"
            />
            <path
                d="M32 36c-11.302 0-19.138.898-23.499 2.73.03 4.422.663 7.76 1.934 9.999.619 1.09 1.389 1.913 2.318 2.459.928.545 2.011.812 3.247.812 3.938 0 6.016-.851 8.045-1.68 2.098-.858 4.147-1.691 7.962-1.637 3.74.053 5.779.858 7.834 1.672C41.906 51.173 43.989 52 48 52c1.236 0 2.32-.267 3.247-.812.929-.546 1.7-1.368 2.318-2.46 1.271-2.239 1.904-5.575 1.934-9.997C51.139 36.898 43.303 36 32 36z"
                :stroke="secondaryColor" class="secondary-color"
            />
        </g>
    </svg>
</template>
